module.exports = __webpack_public_path__ + "static/manipulathor_dof-4b8b50d7a3ecac2c88f86f7b31507cbb.mp4";